import { useEffect } from "react";
import { useSearchParams } from "react-router";

import {
  getFromLocalStorage,
  setToLocalStorage,
} from "@/shared/lib/use-localstorage";

const TRAFFIC_SOURCE_KEY = "traffic_source";

// ABOUTME: Tracks traffic source from ?s= query param for marketing analytics
// ABOUTME: Stores in localStorage and makes it available for registration

/**
 * Capture traffic source from URL query param ?s=
 * Must be called early in app lifecycle to capture before navigation
 */
export function captureTrafficSource(): void {
  if (typeof window === "undefined") return;

  const params = new URLSearchParams(window.location.search);
  const source = params.get("s");

  if (source) {
    setToLocalStorage(TRAFFIC_SOURCE_KEY, source);
  }
}

/**
 * Get stored traffic source (for use during registration)
 */
export function getTrafficSource(): string | null {
  return getFromLocalStorage<string | null>(TRAFFIC_SOURCE_KEY, null);
}

/**
 * Clear stored traffic source (after successful registration)
 */
export function clearTrafficSource(): void {
  if (typeof window !== "undefined") {
    localStorage.removeItem(TRAFFIC_SOURCE_KEY);
  }
}

/**
 * Hook to capture traffic source on mount
 * Call this once in App.tsx to capture ?s= param on initial load
 */
export function useTrafficSource(): void {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const source = searchParams.get("s");

    if (source) {
      setToLocalStorage(TRAFFIC_SOURCE_KEY, source);
      searchParams.delete("s");
      setSearchParams(searchParams, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
